import * as React from 'react';

/** Appended to force a re-announcement of identical text; not spoken and not collapsed out of the DOM. */
export const REANNOUNCE_MARKER = '\u00A0';

export interface UseAnnounceResult {
    message: string;
    announce: (text: string) => void;
}

export const useAnnounce = (): UseAnnounceResult => {
    const [message, setMessage] = React.useState<string>('');

    const lastMessageRef = React.useRef<string>('');

    const announce = React.useCallback((text: string): void => {
        const next = text === lastMessageRef.current ? `${text}${REANNOUNCE_MARKER}` : text;

        lastMessageRef.current = next;
        setMessage(next);
    }, []);

    return { message, announce };
};
